import { render, staticRenderFns } from "./FloatingISI.vue?vue&type=template&id=45b05860&"
var script = {}
import style0 from "./FloatingISI.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./FloatingISI.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports